import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React, { Fragment } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { useSharedPluginState } from '@atlaskit/editor-common/hooks';
import { scrollbarStyles } from '@atlaskit/editor-shared-styles/scrollbar';
import { componentWithCondition } from '@atlaskit/platform-feature-flags-react';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
import { createEditorContentStyle } from '../ContentStyles';
import EditorContentContainer from '../EditorContentContainer';
import PluginSlot from '../PluginSlot';
import WithFlash from '../WithFlash';
var chromelessEditorStyles = css({
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
  lineHeight: '20px',
  height: 'auto',
  overflowX: 'hidden',
  overflowY: 'auto'
},
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
scrollbarStyles, {
  maxWidth: 'inherit',
  boxSizing: 'border-box',
  wordWrap: 'break-word',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  'div > .ProseMirror': {
    outline: 'none',
    whiteSpace: 'pre-wrap',
    padding: 0,
    margin: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '& > :last-child': {
      paddingBottom: "var(--ds-space-100, 0.5em)"
    }
  }
});
export var ContentArea = createEditorContentStyle();
ContentArea.displayName = 'ContentArea';
var EditorContainer = componentWithCondition(function () {
  return editorExperiment('platform_editor_core_static_emotion', true);
}, EditorContentContainer, ContentArea);

// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
var Editor = /*#__PURE__*/function (_React$Component) {
  function Editor() {
    var _this;
    _classCallCheck(this, Editor);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Editor, [].concat(args));
    _defineProperty(_this, "appearance", 'chromeless');
    _defineProperty(_this, "containerElement", null);
    _defineProperty(_this, "renderChrome", function (_ref) {
      var maxContentSize = _ref.maxContentSize;
      var _this$props = _this.props,
        editorDOMElement = _this$props.editorDOMElement,
        editorView = _this$props.editorView,
        editorActions = _this$props.editorActions,
        eventDispatcher = _this$props.eventDispatcher,
        providerFactory = _this$props.providerFactory,
        contentComponents = _this$props.contentComponents,
        customContentComponents = _this$props.customContentComponents,
        maxHeight = _this$props.maxHeight,
        _this$props$minHeight = _this$props.minHeight,
        minHeight = _this$props$minHeight === void 0 ? 30 : _this$props$minHeight,
        popupsMountPoint = _this$props.popupsMountPoint,
        popupsBoundariesElement = _this$props.popupsBoundariesElement,
        popupsScrollableElement = _this$props.popupsScrollableElement,
        disabled = _this$props.disabled,
        dispatchAnalyticsEvent = _this$props.dispatchAnalyticsEvent,
        pluginHooks = _this$props.pluginHooks,
        featureFlags = _this$props.featureFlags;
      var maxContentSizeReached = Boolean(maxContentSize === null || maxContentSize === void 0 ? void 0 : maxContentSize.maxContentSizeReached);
      var _useSharedPluginState = useSharedPluginState(_this.props.editorAPI, ['editorViewMode']),
        editorViewModeState = _useSharedPluginState.editorViewModeState;
      return jsx(WithFlash, {
        animate: maxContentSizeReached
      }, jsx("div", {
        css: [chromelessEditorStyles, maxHeight &&
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css({
          // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
          maxHeight: "".concat(maxHeight, "px")
        }),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css({
          // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
          minHeight: "".concat(minHeight, "px")
        })],
        "data-testid": "chromeless-editor",
        ref: function ref(_ref2) {
          return _this.containerElement = _ref2;
        }
      }, jsx(EditorContainer
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
      , {
        className: "ak-editor-content-area",
        featureFlags: featureFlags,
        viewMode: editorViewModeState === null || editorViewModeState === void 0 ? void 0 : editorViewModeState.mode,
        appearance: _this.appearance
      }, customContentComponents && 'before' in customContentComponents ? customContentComponents.before : customContentComponents, jsx(PluginSlot, {
        editorView: editorView,
        editorActions: editorActions,
        eventDispatcher: eventDispatcher,
        providerFactory: providerFactory,
        appearance: _this.appearance,
        items: contentComponents,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        containerElement: _this.containerElement,
        disabled: !!disabled,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        wrapperElement: _this.containerElement,
        pluginHooks: pluginHooks
      }), editorDOMElement, customContentComponents && 'after' in customContentComponents ? customContentComponents.after : null)));
    });
    return _this;
  }
  _inherits(Editor, _React$Component);
  return _createClass(Editor, [{
    key: "render",
    value: function render() {
      return jsx(RenderWithPluginState, {
        editorAPI: this.props.editorAPI,
        renderChrome: this.renderChrome
      });
    }
  }]);
}(React.Component);
_defineProperty(Editor, "displayName", 'ChromelessEditorAppearance');
export { Editor as default };
function RenderWithPluginState(_ref3) {
  var renderChrome = _ref3.renderChrome,
    editorAPI = _ref3.editorAPI;
  var _useSharedPluginState2 = useSharedPluginState(editorAPI, ['maxContentSize']),
    maxContentSizeState = _useSharedPluginState2.maxContentSizeState;
  return jsx(Fragment, null, renderChrome({
    maxContentSize: maxContentSizeState
  }));
}